export const App = () => {
  return <>Sales Portal MFE</>;
};
